import { BookingMessageVariable } from '@navio/nsdk';
import type { NavioTextVariable } from 'noddi-ui-web';

// The backend fills these in per recipient when it sends (`BookingMessageVariable`).
const COPY: Record<BookingMessageVariable, Omit<NavioTextVariable, 'key'>> = {
  [BookingMessageVariable.FIRST_NAME]: { label: 'First name', example: 'Ola' },
  [BookingMessageVariable.LAST_NAME]: { label: 'Last name', example: 'Nordmann' },
  [BookingMessageVariable.CAR_MAKE]: { label: 'Car make', example: 'Tesla' },
  [BookingMessageVariable.LICENSE_PLATE]: { label: 'License plate', example: 'EL 12345' },
  [BookingMessageVariable.CAR]: { label: 'Car and plate', example: 'Tesla (EL 12345)' },
  [BookingMessageVariable.BOOKING_SLUG]: { label: 'Booking reference', example: 'AB12CD' },
  [BookingMessageVariable.BOOKING_URL]: { label: 'Booking link', example: 'noddi.no/b/AB12CD' },
  [BookingMessageVariable.BOOKING_DATE]: { label: 'Booking date', example: 'Tuesday 21. Oct' },
  [BookingMessageVariable.BOOKING_START]: { label: 'Window start', example: '12:00' },
  [BookingMessageVariable.BOOKING_END]: { label: 'Window end', example: '17:00' },
  [BookingMessageVariable.WORKER_FIRST_NAME]: { label: 'Worker', example: 'Robin' },
  [BookingMessageVariable.DATE_TODAY]: { label: "Today's date", example: 'Tuesday 21. Oct' },
  [BookingMessageVariable.DATE_TOMORROW]: { label: "Tomorrow's date", example: 'Wednesday 22. Oct' }
};

export const BOOKING_MESSAGE_VARIABLES: NavioTextVariable[] = Object.entries(COPY).map(([key, copy]) => ({
  key,
  ...copy
}));

// Two SMS segments; the bulk send endpoint rejects longer bodies.
export const BOOKING_MESSAGE_MAX_LENGTH = 320;
